module.exports = __webpack_public_path__ + "img/1.b867c263.png";